export const RECAP_BUTTON_HEIGHT = '44px';
export const RECAP_OPALITE_BLUE = 'opalite.600';
export const RECAP_OPALITE_BLUE_TINT_08 = 'opalite.50';
export const RECAP_OPALITE_BLUE_TINT_12 = 'opalite.50';
export const RECAP_OPALITE_BLUE_TINT_14 = 'opalite.100';
export const RECAP_OPALITE_BLUE_TINT_15 = 'opalite.100';
export const RECAP_OPALITE_BLUE_BORDER = 'opalite.200';

export const RECAP_CARD_BOUNDARY_PROPS = {
  borderRadius: 'lg',
  borderWidth: '1px',
  overflow: 'hidden',
  position: 'relative',
} as const;

export const RECAP_PRIMARY_BUTTON_PROPS = {
  variant: 'opalitePrimary',
  bg: RECAP_OPALITE_BLUE,
  h: RECAP_BUTTON_HEIGHT,
  minH: RECAP_BUTTON_HEIGHT,
  borderRadius: 'lg',
  fontWeight: 'medium',
  _hover: {bg: RECAP_OPALITE_BLUE},
  _active: {bg: RECAP_OPALITE_BLUE},
  _focusVisible: {
    outline: '2px solid',
    outlineColor: RECAP_OPALITE_BLUE,
    outlineOffset: '2px',
    boxShadow: 'none',
  },
};

export const RECAP_SECONDARY_BUTTON_PROPS = {
  variant: 'outline',
  h: RECAP_BUTTON_HEIGHT,
  minH: RECAP_BUTTON_HEIGHT,
  borderRadius: 'lg',
  borderColor: RECAP_OPALITE_BLUE,
  color: RECAP_OPALITE_BLUE,
  bg: 'white',
  fontWeight: 'medium',
  _hover: {
    bg: RECAP_OPALITE_BLUE_TINT_08,
    borderColor: RECAP_OPALITE_BLUE,
    color: RECAP_OPALITE_BLUE,
  },
  _active: {bg: RECAP_OPALITE_BLUE_TINT_12, borderColor: RECAP_OPALITE_BLUE},
  _focusVisible: {
    outline: '2px solid',
    outlineColor: RECAP_OPALITE_BLUE,
    outlineOffset: '2px',
    boxShadow: 'none',
  },
};

export const RECAP_GRAY_SECONDARY_BUTTON_PROPS = {
  variant: 'outline',
  h: RECAP_BUTTON_HEIGHT,
  minH: RECAP_BUTTON_HEIGHT,
  borderRadius: 'lg',
  borderColor: 'gray.300',
  color: 'gray.700',
  bg: 'white',
  fontWeight: 'medium',
  _hover: {bg: 'gray.50', borderColor: 'gray.400', color: 'gray.800'},
  _active: {bg: 'gray.100', borderColor: 'gray.500'},
  _focusVisible: {
    outline: '2px solid',
    outlineColor: 'gray.600',
    outlineOffset: '2px',
    boxShadow: 'none',
  },
};
